import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useSelectedProjectStore} from "@domains/boards/stores/selected-project.store";
import {useResetStores} from "@shared/composables/use-reset-stores";

export const getProjectResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext,
): Promise<void> => {

    const editorStore = useSelectedProjectStore();
    useResetStores().resetMany([editorStore]);
    const projectId: string = to.params.projectId as string;
    editorStore.loadProject(projectId).then(() => next())

};
